import { whatsappSubscriptionUrl } from "../constants/business";
import { SECTION_IDS } from "../constants/sections";
import { SUBSCRIPTION_STRINGS } from "../constants/strings";

function SubscriptionSection() {
  return (
    <section
      id={SECTION_IDS.subscription}
      className="section subscription-section"
    >
      <div className="section-inner">
        <div className="section-heading">
          <p className="eyebrow">{SUBSCRIPTION_STRINGS.eyebrow}</p>
          <h2>{SUBSCRIPTION_STRINGS.heading}</h2>
          <p>
            {SUBSCRIPTION_STRINGS.paragraphBeforeStrong}{" "}
            <strong>{SUBSCRIPTION_STRINGS.paragraphStrong}</strong>{" "}
            {SUBSCRIPTION_STRINGS.paragraphAfterStrong}
          </p>
        </div>

        <div className="subscription-layout">
          <div
            className="highlight-panel"
            aria-label={SUBSCRIPTION_STRINGS.highlightsAriaLabel}
          >
            {SUBSCRIPTION_STRINGS.highlights.map((item) => (
              <div className="highlight-item" key={item}>
                <span aria-hidden="true">✓</span>
                <p>{item}</p>
              </div>
            ))}
          </div>

          <div className="subscription-cta-panel">
            <p>{SUBSCRIPTION_STRINGS.ctaParagraph}</p>
            <a
              className="button button-primary"
              href={whatsappSubscriptionUrl}
              target="_blank"
              rel="noreferrer"
            >
              {SUBSCRIPTION_STRINGS.ctaPrimaryLabel}
            </a>
            <a
              className="button button-secondary"
              href={`#${SECTION_IDS.enquiry}`}
            >
              {SUBSCRIPTION_STRINGS.ctaSecondaryLabel}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SubscriptionSection;
